import { render, staticRenderFns } from "./room-control-settings.vue?vue&type=template&id=1d1bc324&"
import script from "./room-control-settings.vue?vue&type=script&lang=ts&"
export * from "./room-control-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports